module.exports = __webpack_public_path__ + "img/SES_235415000.ab4b6e0a.jpg";